import React from 'react';
import { Tabs } from '@aws-amplify/ui-react';
import HomePageProject from '../project/HomePageProject';
import HomePageuser from '../user/HomePageUser';
import HomePageAssing from '../assing/HomePageAssing';
import JustAdminMessage from '../commons/JustAdminMessage';

const AdminPanel = (props) => {


  return (
    <>
    {props.role === 'Administrador'? (
      <div className="container">
        <Tabs
          spacing="relative"
          justifyContent="flex-start"
          defaultValue='1'
          items={[
              { label: 'Proyectos', value: '1', content: <HomePageProject/> },
              { label: 'Usarios', value: '2', content: <HomePageuser/> },
              { label: 'Asignar', value: '3', content: <HomePageAssing/> },
          ]}
          />
        {
          //  <ProjectCreateForm />
          /* <CreateUserForm />
        <CreateProjectForm />
        <AssignProjectForm /> */}
      </div>
      ) : (
        <JustAdminMessage/>
      )
    }
    </>
  );
};

export default AdminPanel;